export default __webpack_public_path__ + "images/5a69f6502fd78dc814891119d1e411fe-commission_module.png";